import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { FeatureFlags } from '@app/core/feature-flags/feature-flags';
import { LaunchDarklyService } from '@app/core/feature-flags/launchdarkly.service';

@Injectable({
  providedIn: 'root',
})
export class PreferredPharmacyRevampGating {
  constructor(readonly launchDarklyService: LaunchDarklyService) {}

  isEnabled$(): Observable<boolean> {
    return this.launchDarklyService.featureFlag$(FeatureFlags.PHARMEX_PREFERRED_PHARMACY_REVAMP, false);
  }
}
